import { v4 as uuid } from 'uuid';
import { AnessaListItem } from '../../anessa-list-item.interface';
import { FeedstockBmpCurveItem } from '../../project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-curve.model';
import { cloneDeep } from 'lodash-es';
import { ProjectInputItem } from '../../data-structures/project/project-input-item.model';


export interface ScenarioInputInterface {
  id: string;
  uuid: string | null;
  nameElements: string[];
  path: string[];
  scenarioValue: number | null;
  baselineValue: number | null;
  unit: string;
  curve: FeedstockBmpCurveItem[];
}

export class ScenarioInput implements AnessaListItem {
  id: string;
  uuid: string | null;
  nameElements: string[];
  path: string[];
  scenarioValue: number | null;
  baselineValue: number | null;
  unit: string;
  curve: FeedstockBmpCurveItem[];

  constructor(param: ScenarioInputInterface = {
    id: '',
    uuid: null,
    nameElements: [],
    path: [],
    scenarioValue: null,
    baselineValue: null,
    unit: '',
    curve: [],
  }) {
    this.id = param.id;
    this.uuid = param.uuid ? param.uuid : uuid();
    this.nameElements = param.nameElements;
    this.path = param.path;
    this.scenarioValue = param.scenarioValue;
    // If a scenario existed before these models were updated
    // this will check for the old value property and assign it
    // to the new scenarioValue property IF there is no current value assigned
    if (param['value'] !== undefined || param['value'] !== null
      && param.scenarioValue === undefined
    ) {
      this.scenarioValue = param['value'];
    }
    this.baselineValue = param.baselineValue;
    this.unit = param.unit;
    this.curve = param.curve;
  }

  /**
   * Populates overlapping properties with the data in the provided ProjectInputItem
   * @param projectInput is a ProjectInputItem that contains data used to populate overlapping properties of this class.
   */
  populateFromProjectInput(projectInput: ProjectInputItem) {
    this.id = projectInput.id;
    this.path = projectInput.path;
    this.nameElements = projectInput.nameElements;
    this.baselineValue = projectInput.value;
    this.unit = projectInput.unit;
    this.curve = projectInput.curve;
  }

  /**
   * Returns a deep copy of this class.
   */
  deepCopy(): ScenarioInput {
    return new ScenarioInput(cloneDeep(this));
  }

  /**
   * Returns a copy of this class with the uuid removed. Used to duplicate
   * the scenario input without containing a duplicated uuid.
   */
  duplicate(): ScenarioInput {
    const dupe = this.deepCopy();
    dupe.uuid = uuid();
    return dupe;
  }
}
